/**
 * Reads the exception name AppSync attaches to a GraphQL error.
 *
 * AppSync's `util.error(message, errorType)` serialises `errorType` as a
 * TOP-LEVEL field on each error in the GraphQL response — it is NOT placed
 * under `extensions`, and Apollo Client does not fold it in. Reading only
 * `extensions.errorType` therefore never matches a real AppSync response
 * (the classification silently fails and callers fall back to generic error
 * handling). Read the top-level field first, then fall back to
 * `extensions.errorType` for any transport or test double that places it there.
 */
export function getAppSyncErrorType(
  error:
    | {
        errorType?: unknown;
        extensions?: { [key: string]: unknown } | null;
      }
    | undefined,
): string | undefined {
  if (!error) return undefined;
  if (typeof error.errorType === 'string') return error.errorType;
  const fromExtensions = error.extensions?.['errorType'];
  return typeof fromExtensions === 'string' ? fromExtensions : undefined;
}
